module.exports = __webpack_public_path__ + "img/122.8b6ad96f.jpg";